<div>
  <mat-progress-bar mode="indeterminate" *ngIf="show_progressbar==true"></mat-progress-bar>

  <mat-accordion>

    <mat-expansion-panel (opened)="panelOpenState1 = true"
                                         (closed)="panelOpenState1 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>Change System Password</mat-panel-title>
      </mat-expansion-panel-header>

        <div class="shadowBox col-sm-12" *ngIf="endpoint_data.system_password">

          <mat-form-field class="col-sm-6" style="margin-right: 20px;">
            <mat-label>System Password</mat-label>
            <input matInput [formControl]="system_password" type="password">
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="updateSystemPassword()" [disabled]="passwordProcessingFlag">Change Password</button>
          <!-- <p style="color: red;"> {{updatePasswordError}} </p> -->
          <p style="color: darkslateblue;"> *Used to change the unit admin password and VMS system password after trying to connect to unit by it. </p>

        </div>

        <div class="shadowBox col-sm-12" *ngIf="!endpoint_data.system_password">
          <div class="row">

            <div class="col-sm-12 text-center mb-4" >
              <h3 style="background-color: black; color: white; padding: 10px;">Select the Market and location for the unit along with the password</h3>

              <mat-form-field appearance="fill" style="width: 30%; margin: 0px 2px 0px 2px;">
                <mat-label>Units Market</mat-label>
                <mat-select  [(value)]="selectedMarketName" (selectionChange)="fetchMarketLocations()">
                  <mat-option *ngFor="let market of availableMarkets" [value]="market.text">{{market.text}}</mat-option>
                </mat-select >
              </mat-form-field>

              <mat-form-field appearance="fill" style="width: 25%;margin: 0px 2px 0px 2px;">
                <mat-label>Locations Available</mat-label>
                <mat-select  [(value)]="selectedMarketLocationId">
                  <mat-option *ngFor="let location of availableMarketLocations" [value]="location">{{location.text}}</mat-option>
                </mat-select >
              </mat-form-field>
            </div>

            <div class="div col-sm-12">
              <form (ngSubmit)="openDialogInsertNewPassword()" #ff="ngForm">
                <div class="col-sm-12">
                  <!-- <mat-form-field class="col-sm-6" style="margin-right: 20px;">
                    <input matInput [formControl]="system_password" type="password">
                  </mat-form-field> -->
                  <mat-form-field  appearance="fill" style="width: 75%;">
                    <mat-label>System Password</mat-label>
                    <input matInput [(ngModel)]="toBeSentPassword"  autocomplete="off"
                    name="system_password_model" required maxlength="50" minlength="6"
                     #system_password_model="ngModel" type="password">
                    <mat-error *ngIf="system_password_model.errors" style="color: red;">
                      Password Minimum six characters
                    </mat-error>
                  </mat-form-field>
                </div>
                <div id="buttons" class="col-sm-12">
                  <button mat-raised-button  color="primary"
                  style="margin-left: auto;margin-right: auto; margin-top: 10px !important;"
                  [disabled]="passwordProcessingFlag"
                  type="submit" [disabled]="!ff.valid || !system_password ||!selectedMarketLocationId.id">Confirm</button>
                </div>
              </form>
            </div>


          </div>

        </div>

    </mat-expansion-panel>


    <mat-expansion-panel (opened)="panelOpenState2 = true"
                                         (closed)="panelOpenState2 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>Update System Location</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="shadowBox col-sm-12">

          <h5 *ngIf="selected_parent_folder">
            Current Location: <b>{{selected_parent_folder.text}}</b></h5>
            <h5  *ngIf="selected_folder === undefined ">Choose destination folder location from tree</h5>
          <div *ngIf="selected_folder !== undefined ">
            <mat-label>Selected Location</mat-label>
            <h5>Move system to <b> {{selected_folder.text}}</b></h5>
            <input [value]="selected_folder.text" type="hidden">
          </div>
          <hr>
          <button [disabled]="disableUpdateButton()" mat-button type="button"
          *ngIf="selected_folder !== undefined "
          (click)="openDialog()" color="primary"><i class="fa fa-database"></i> Update Location
        </button>
        <div style="color:red;margin-left: 15px; font-size: small;" *ngIf="disableUpdateButton()">{{updateBtnErrorMsg}}</div>


      </div>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelOpenState3 = true"
    (closed)="panelOpenState3 = false">
<mat-expansion-panel-header>
<mat-panel-title>Remedy Market Information</mat-panel-title>
</mat-expansion-panel-header>

<div class="shadowBox col-sm-12" *ngIf="endpoint_data.market_location_id">
<div class="row">

<div class="col-sm-12 text-center mb-4" >
<h3 style="background-color: black; color: white; padding: 10px;">Select the Market and location for the unit</h3>

<mat-form-field appearance="fill" style="width: 30%; margin: 0px 2px 0px 2px;">
<mat-label>Units Market</mat-label>
<mat-select  [(value)]="selectedMarketName" (selectionChange)="fetchMarketLocations()">
<mat-option *ngFor="let market of availableMarkets" [value]="market.text">{{market.text}}</mat-option>
</mat-select >
</mat-form-field>

<mat-form-field appearance="fill" style="width: 25%;margin: 0px 2px 0px 2px;">
<mat-label>Locations Available</mat-label>
<mat-select  [(value)]="selectedMarketLocationId">
<mat-option *ngFor="let location of availableMarketLocations" [value]="location">{{location.text}}</mat-option>
</mat-select >
</mat-form-field>
<div>
  <button mat-raised-button color="primary" (click)="updateSystemMarket()" [disabled]="passwordProcessingFlag">Change System Market</button>
</div>
</div>

</div>

</div>

    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelOpenState4 = true"
    (closed)="panelOpenState4 = false" *ngIf="endpoint_data.system_password">
      <mat-expansion-panel-header>
      <mat-panel-title>Update VMS System Password</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="shadowBox col-sm-12" *ngIf="endpoint_data.system_password">

      <mat-form-field class="col-sm-6" style="margin-right: 20px;">
      <mat-label>System Password</mat-label>
      <input matInput [formControl]="vms_system_password" type="password">
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="openDialogUpdateVmsPassword()" [disabled]="passwordProcessingFlag">Change Password</button>
      <p style="color: red;"> {{updatePasswordError2}} </p>
      <p style="color: darkslateblue;"> *Used to update VMS system password after trying to connect to unit by it.</p>

    </div>

    </mat-expansion-panel>

    </mat-accordion>
</div>
